// Why a replay could not be listed or opened, as a code (replayApi.ts) and its sentence in the current language.
import { t } from '../i18n/index.js';

export type ReplayError = 'notFound' | 'unavailable' | 'network' | 'busy' | 'corrupt' | 'list' | 'outdated';

export const replayErrorText = (e: ReplayError): string => t(`replayError.${e}` as const);
